const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/plan/budgeting/fiscal_periods.new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/plan/budgeting/fiscal_periods/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Create Fiscal Period",
      description: "Page title"
    })
  }
});